import React from "react";
import { Pagination as MUIPagination } from "@mui/material";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  SelectChangeEvent,
} from "@mui/material";

interface PaginationProps {
  page: number; // 1-based
  count: number; // Total pages
  onChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  rowsPerPage: number;
  onRowsPerPageChange: (event: SelectChangeEvent<number>) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  page,
  count,
  onChange,
  rowsPerPage,
  onRowsPerPageChange,
}) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
      padding={2}
    >
      <MUIPagination
        count={count}
        page={page}
        siblingCount={1} 
        boundaryCount={1}
        onChange={onChange}
        color="primary"
        showFirstButton
        showLastButton
        variant="outlined"
        shape="rounded"
        size="large"
      />
      <FormControl size="small" style={{ marginLeft: 20, minWidth: 120 }}>
        <InputLabel id="amount-label">ჩანაწერები</InputLabel>
        <Select
          labelId="amount-label"
          id="amount-select"
          value={rowsPerPage}
          label="ჩანაწერები"
          onChange={onRowsPerPageChange}
        >
          {[10, 15, 30, 50].map((amount) => (
            <MenuItem key={amount} value={amount}>
              {amount}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default Pagination;
